import classNames from 'classnames'
import { ComponentProps, ReactElement } from 'react'

interface Props extends ComponentProps<'svg'> {
  color?: string
}

export function IconDamagedShipment({ color = 'currentColor', className, ...props }: Props): ReactElement {
  return (
    <svg
      fill="none"
      viewBox="8 8 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(className, 'w-[1em] h-[1em]')}
      {...props}
    >
      <path
        d="M17.9 11.8l-2.7 3.7-.4.5c-.1.1-.1.3 0 .5l.6 1.2-1.8-1.3.4-.8 2.1-3.2c.1-.2.1-.4 0-.6l-3-3.8h-2c-.6 0-1.2.4-1.4 1l-1.6 4.7c0 .2-.1.3-.1.5v8.3A1.54 1.54 0 0 0 9.5 24h13a1.54 1.54 0 0 0 1.5-1.5v-8.3c0-.2 0-.3-.1-.5L22.3 9c-.2-.6-.8-1-1.4-1h-5.5l2.5 3.8zm1.6.3c.1-.2.1-.4 0-.5l-1.3-2.1H21l1.5 4.5h-4.4l1.4-1.9zm-5.1 0L13.2 14H9.7l1.5-4.5h1.2l2 2.6zm8.2 10.4h-13v-7h2.6l-.5.8c-.1.2-.1.5.1.6l5.8 4.2c.1.1.2.1.3.1s.2 0 .3-.1c.2-.1.2-.4.2-.6l-1.9-4.3.6-.8h5.6v7.1h-.1z"
        fill={color}
      />
    </svg>
  )
}
